import Newhome from 'pagecomponents/newhome'

let HomePage = Newhome;
export default HomePage;
